import moment from 'moment';

export function getViewsDataAsTimeSeries(views) {
  // Sort views by date
  const sortedViews = [...views].sort((a, b) => new Date(a.date) - new Date(b.date));

  // Group views by date
  const viewsByDate = {};
  sortedViews.forEach((view) => {
    const date = moment(view.createdAt).format('YYYY-MM-DD');
    viewsByDate[date] = (viewsByDate[date] || 0) + 1;
  });

  // Create data points only for dates with views
  const datesWithViews = Object.keys(viewsByDate)?.sort() || [];
  let cumulativeCount = 0;
  const dataPoints = datesWithViews?.map(date => {
    cumulativeCount += viewsByDate[date];
    return {
      x: date,
      y: cumulativeCount,
    };
  });

  return dataPoints;
}

export function getAnalyticsDataSetSettings() {
  return {
    borderColor: '#1E1E20',
    borderWidth: 2,
    tension: 0.1,
    fill: true,
    pointHoverRadius: 6,
    pointBackgroundColor: '#0dcb82',
    pointBorderColor: '#752D61',
    pointBorderWidth: 1,
    backgroundColor: (context) => {
      const { chart } = context;
      const { ctx, chartArea } = chart;
      if (!chartArea) return 'rgba(75, 192, 192, 0.3)';
      // Create a left-to-right (horizontal) gradient
      const gradient = ctx.createLinearGradient(chartArea.left, chartArea.top, chartArea.right, chartArea.top);
      gradient.addColorStop(0, '#1E1E20');
      gradient.addColorStop(1, '#752D61');
      return gradient;
    },
  };
}
